var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.vertical ? 'mx-' + _vm.marginLevel : 'my-' + _vm.marginLevel},[(_vm.bold)?_c('v-divider',{staticClass:"line-border",staticStyle:{"border-radius":"10%"},style:({
      'width': _vm.vertical ? 'auto' : _vm.long,
      'height': _vm.vertical ? _vm.long : 'auto',
      'border': _vm.borderType,
      'border-color': _vm.borderColor,
      'border-width': _vm.borderWidth + 'px'
    }),attrs:{"vertical":_vm.vertical}}):_c('div',{staticClass:"line-border",style:({
      'width': _vm.vertical ? 'auto' : _vm.long,
      'height': _vm.vertical ? _vm.long : 'auto',
      'border-bottom': _vm.vertical ? 'none' : _vm.borderType + ' ' + _vm.borderWidth + 'px ' + _vm.borderColor,
      'border-right': _vm.vertical ? _vm.borderType + ' ' + _vm.borderWidth + 'px ' + _vm.borderColor + ' !important' : 'none'
    })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }